export const UrCarConst = {
    SELLERID: 'SELLERID',
    SELLERDATA: 'SELLERDATA',
    ERROR: 'ERROR'
};
const initialState =  {}
console.log("initialState===",initialState)

const CarListReducer = (state = {payload:initialState}, action) => {
    switch (action.type) {
        case UrCarConst.SELLERID:
            console.log("inside success reducer")
            console.log("Payload",action)
            return {
                carlist: 'carlist-sellerid',
                payload: action.payload

            };
        case UrCarConst.SELLERDATA:
            console.log("inside seller data reducer")
            console.log("Payload",action)
            return {
                carlist: 'carlist-sellerdata',
                payload: action.payload

            };
        case UrCarConst.ERROR:
            console.log("inside err reducer")
            console.log("Payload",action.payload)
            return {
                carlist: 'carlist-fail',
                payload: action.payload
            };
        default:
            console.log("Inside default of the reducer");
            console.log("Payload - state",state)
            return state
            
    }
    

}

export default CarListReducer; 